import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSEO } from "../hooks/useSEO";

function Privacy() {
  useSEO({
    title: "Privacy Policy | Empower Web",
    description:
      "Read our privacy policy to understand how Empower Web collects, uses, and protects your personal information.",
    canonical: "https://empowerweb.in/privacy-policy",
    ogTitle: "Privacy Policy | Empower Web",
    ogDescription:
      "Learn about how Empower Web protects your privacy and data.",
    keywords: "privacy policy, data protection, privacy, terms, legal",
  });
  return (
    <div>
      <Header />
      <Navbar />
      <hr />
      <section style={{ padding: "30px 40px", minHeight: "70vh" }}>
        <div style={{ maxWidth: "1000px" ,  margin: "0 auto" }}>
          <h1
            style={{
              fontSize: "2.5rem",
              color: "#0868a0",
              marginBottom: "30px",
              textAlign: "left",
            }}
          >
            Privacy Policy
          </h1>{" "}







          <div style={{ lineHeight: "1.8", color: "#666", fontSize: "1rem" }}>
            <h2
              style={{
                color: "#0868a0",
                marginTop: "30px",
                marginBottom: "15px",
                textAlign: "left",
              }}
            >
              1. Introduction
            </h2>
            <p
              style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}
            >
              At EmpowerWeb, we value your privacy and are committed to
              protecting your personal information. This Privacy Policy explains
              how we collect, use, and safeguard your data when you visit our
              website.
            </p>

            <h2
              style={{
                color: "#0868a0",
                marginTop: "30px",
                marginBottom: "15px",
                textAlign: "left",
              }}
            >
              2. Information We Collect
            </h2>
            <p
              style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}
            >
              We may collect personal information such as your name, email
              address, phone number, and any details you provide through contact
              forms on our website. Additionally, we may collect non-personal
              information like your IP address, browser type, and browsing
              behavior.
            </p>

            <h2
              style={{
                color: "#0868a0",
                marginTop: "30px",
                marginBottom: "15px",
                textAlign: "left",
              }}
            >
              3. How We Use Your Information
            </h2>
            <p
              style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}
            >
              We use your information to provide services, respond to inquiries,
              and improve our offerings. We do not sell or share your
              information with third parties without consent.
              <br />
              1. Respond to your inquiries and provide our services <br />
              2. Improve our website and user experience <br />
              3. Send updates, promotional content, or marketing communications{" "}
              <br />
              4. Analyze website traffic and performance
            </p>

            <h2
              style={{
                color: "#0868a0",
                marginTop: "30px",
                marginBottom: "15px",
                textAlign: "left",
              }}
            >
              4. Data Sharing and Third-Party Services
            </h2>
            <p
              style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}
            >
              We do not sell, trade, or rent your personal information. However,
              we may share data with trusted third-party services that help us
              operate our website, such as analytics providers, hosting
              services, or marketing tools.
            </p>

            <h2
              style={{
                color: "#0868a0",
                marginTop: "30px",
                marginBottom: "15px",
                textAlign: "left",
              }}
            >
              5. Data Security
            </h2>
            <p
              style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}
            >
              We implement appropriate security measures to protect your
              personal data from unauthorized access, misuse, or disclosure.
              However, no method of transmission over the internet is 100%
              secure.
            </p>

            <h2
              style={{
                color: "#0868a0",
                marginTop: "30px",
                marginBottom: "15px",
                textAlign: "left",
              }}
            >
              6. Updates to This Policy
            </h2>
            <p
              style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}
            >
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with an updated revision date.
            </p>

            <h2
              style={{
                color: "#0868a0",
                marginTop: "30px",
                marginBottom: "15px",
                textAlign: "left",
              }}
            >
              7. Contact Us
            </h2>
            <p
              style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}
            >
              If you have any questions about this Privacy Policy, please
              contact us at privacy@empowerweb.in
            </p>
          </div>
        </div>
      </section>
      <Footer />
     
    </div>
  );
}

export default Privacy;
